import { render, staticRenderFns } from "./SCF.vue?vue&type=template&id=7a49d58e&"
import script from "./SCF.vue?vue&type=script&lang=js&"
export * from "./SCF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a49d58e')) {
      api.createRecord('7a49d58e', component.options)
    } else {
      api.reload('7a49d58e', component.options)
    }
    module.hot.accept("./SCF.vue?vue&type=template&id=7a49d58e&", function () {
      api.rerender('7a49d58e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/SCF.vue"
export default component.exports